import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";

const PrintSection2 = ({ section2 }) => {
  const ciiQualifications = [
    "FPC1",
    "FPC2",
    "FPC3",
    "CF1",
    "CF2",
    "CF3",
    "CF4",
    "CF5",
    "CF6",
    "MAQ",
  ];
  const libifQualifications = [
    "CeMAP1",
    "CeMAP2",
    "CeMAP3",
    "CeMAP_Bridge",
    "CeFA1",
    "CeFA2",
    "CeFA3",
    "CeFA4",
    "IFS_DIPLOMA",
  ];
  const joQualifications = [
    "JO1",
    "JO2",
    "JO3",
    "JO4",
    "JO5",
    "JO6",
    "JO7",
    "JO8",
    "JO9",
    "JO10",
    "JO11",
    "JO12",
  ];
  const roQualifications = [
    "RO1",
    "RO2",
    "RO3",
    "RO4",
    "RO5",
    "RO6",
    "RO7",
    "RO8",
  ];

  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 2 – Professional Qualifications
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        2.1 Professional Standing
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Please select the relevant boxes to indicate the qualifications that you
        have attained. Copies of the appropriate examination certificates must
        be sent to the Rosemount Recruitment Team together with a copy of your
        Learning Statement or Academic Summary. If you are already a financial
        planner, please also submit your Statement of Professional Standing.
      </Text>

      <View style={PrintApplicationStyles.inputtable}>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputSection}>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>CII</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {Object.entries(section2 || {})
                        .filter(
                          ([key, value]) =>
                            ciiQualifications.includes(key) && value,
                        )
                        .map(([key]) => key)
                        .join(", ") || ""}
                    </Text>
                  </View>
                </View>
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    Walbrook Institute London (LIBF/IFS)
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {Object.entries(section2 || {})
                        .filter(
                          ([key, value]) =>
                            libifQualifications.includes(key) && value,
                        )
                        .map(([key]) => key)
                        .join(", ") || ""}
                    </Text>
                  </View>
                </View>

                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>CII JO</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {Object.entries(section2 || {})
                        .filter(
                          ([key, value]) =>
                            joQualifications.includes(key) && value,
                        )
                        .map(([key]) => key)
                        .join(", ") || ""}
                    </Text>
                  </View>
                </View>

                {/* RO Qualifications */}
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>CII RO</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {Object.entries(section2 || {})
                        .filter(
                          ([key, value]) =>
                            roQualifications.includes(key) && value,
                        )
                        .map(([key]) => key)
                        .join(", ") || ""}
                    </Text>
                  </View>
                </View>

                {/* CII DIPLOMA */}
                <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>CII DIPLOMA</Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {section2?.CII_DIPLOMA ? "CII_DIPLOMA" : ""}
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Do you have any Equity Release qualifications? (If yes, please
                forward a copy of your relevant qualification certificate)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section2?.Equity_Release === true
                    ? "Yes"
                    : section2?.Equity_Release === false
                      ? "No"
                      : section2?.Equity_Release === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Do you have the Long Term Care qualifications? (If yes, please
                forward a copy of your relevant qualification certificate)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section2?.Long_Term_Care === true
                    ? "Yes"
                    : section2?.Long_Term_Care === false
                      ? "No"
                      : section2?.Long_Term_Care === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If no financial services qualifications have been obtained,
                please provide full details of any higher level qualifications
                obtained.
              </Text>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Qualification 1
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section2?.Qualification1 || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Qualification 2
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section2?.Qualification2 || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Qualification 3
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section2?.Qualification3 || ""}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PrintSection2;
